import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DealerParam, SpraNetSalePriceRealisedParams } from 'src/app/Models/ops';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-net-sale-price-realised',
  templateUrl: './spra-net-sale-price-realised.component.html',
  styleUrls: ['./spra-net-sale-price-realised.component.css']
})
export class SpraNetSalePriceRealisedComponent implements OnInit {
  @Output("DealerChange") DealerChange: EventEmitter<any> = new EventEmitter(); 
  private utility: Utility;
  public SaleType: string;
  public IsRental:boolean = false;
  public PartnerDetailList:any[] = [];
  public SpraNetSalePriceRealisedParams: SpraNetSalePriceRealisedParams;
  public DealerParam:DealerParam;
  constructor(
    private cookieService: CookieService
    , private _NotificationService: NotificationService
    , private _MasterServiceService: MasterService
  ) {
    this.SaleType = "";
    this.SpraNetSalePriceRealisedParams = new SpraNetSalePriceRealisedParams();
    this.DealerParam=  new DealerParam();
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {
    
  }


  BindDealerList(partnerId:number=0){
    this.PartnerDetailList = [];
    this._MasterServiceService.GetDealer(this.DealerParam).subscribe((d:any)=>{      
      let _PartnerDetail:any ={"partnerId":0,"partnerName":"--- Select ---","partnerCode":""};
      this.PartnerDetailList.push(_PartnerDetail);
      if(d){
        this.PartnerDetailList = this.PartnerDetailList.concat(d);    
      }
      
      this.SpraNetSalePriceRealisedParams.PartnerId = partnerId;
    })
  }


  Validation(): boolean {
    if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.BuyBack)){
      this._NotificationService.showError("Buy Back can not be negative. ", "Net Sale Price");
      return false;
    }else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.ReSaleValueBuyBack)){
      this._NotificationService.showError("Resale Value of buyback can not be negative. ", "Net Sale Price");
      return false;
    }else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.RebateWoGST)){
      this._NotificationService.showError("Rebate without GST can not be negative. ", "Net Sale Price");
      return false;
    }else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.BoughtOutItems)){
      this._NotificationService.showError("BoughtOut Items can not be negative.", "Net Sale Price");
      return false;
    }else if (this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.ReSaleValueBuyBack)
    && !this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.BuyBack)
  ) {
    this._NotificationService.showError("Resale value of buyback can not be entered without buback.", "Net Sale Price ");
    return false;
  }else if (this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.BuyBack)
      && !this.utility.CheckStringRequired(this.SpraNetSalePriceRealisedParams.BuyBackRemarks)
    ) {
      this._NotificationService.showError("Please enter Buyback remarks .", "Net Sale Price ");
      return false;
    } else if (this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.BoughtOutItems)
      && !this.utility.CheckStringRequired(this.SpraNetSalePriceRealisedParams.BoughtOutItemsRemarks)
    ) {
      this._NotificationService.showError("Please enter bought out item remarks .", "Net Sale Price ");
      return false;
    } else if (this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.AgentCommission)
      && this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.InstallationCommission)
    ) {
      this._NotificationService.showError("Either Agent/Installation commission can be entered. ", "Net Sale Price");
      return false;
    }
    else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.DealerCommission)){
      this._NotificationService.showError("Dealer commission can not be negative. ", "Net Sale Price");
      return false;
    }
    else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.AgentCommission)){
      this._NotificationService.showError("Agent commission can not be negative. ", "Net Sale Price");
      return false;
    }
    else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.InstallationCommission)){
      this._NotificationService.showError("Installation commission can not be negative.", "Net Sale Price");
      return false;
    }
    else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.FreeItem)){
      this._NotificationService.showError("Free Item can not be negative.", "Net Sale Price");
      return false;
    }
    else if (!this.utility.CheckNumberRequiredWithZero(this.SpraNetSalePriceRealisedParams.OtherDiscount)){
      this._NotificationService.showError("Free Item can not be negative.", "Net Sale Price");
      return false;
    }
    else if (this.SaleType == "DL" && !this.utility.CheckNumberRequired(this.SpraNetSalePriceRealisedParams.PartnerId)) {
    this._NotificationService.showError("Please Select Dealer. ", "Net Sale Price");
    return false;
    
  } 
    
    else {
      return true;
    }

  }


  ResetCommission(){
    this.SpraNetSalePriceRealisedParams.AgentCommission = 0;
    this.SpraNetSalePriceRealisedParams.InstallationCommission = 0;
    this.SpraNetSalePriceRealisedParams.DealerCommission = 0;
  }

  DealerModelChange(){
    this.DealerChange.emit(this.SpraNetSalePriceRealisedParams.PartnerId);
  }

}
